/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScreeningMatchProvider {
    DOW_JONES = 'DOW_JONES',
    SALV = 'SALV',
    OTHER = 'OTHER'
}


export function instanceOfInternalApiScreeningMatchProvider(value: any): boolean {
    for (const key in InternalApiScreeningMatchProvider) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScreeningMatchProvider, key)) {
            if (InternalApiScreeningMatchProvider[key as keyof typeof InternalApiScreeningMatchProvider] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScreeningMatchProviderFromJSON(json: any): InternalApiScreeningMatchProvider {
    return InternalApiScreeningMatchProviderFromJSONTyped(json, false);
}

export function InternalApiScreeningMatchProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningMatchProvider {
    return json as InternalApiScreeningMatchProvider;
}

export function InternalApiScreeningMatchProviderToJSON(value?: InternalApiScreeningMatchProvider | null): any {
    return value as any;
}

export function InternalApiScreeningMatchProviderToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScreeningMatchProvider {
    return value as InternalApiScreeningMatchProvider;
}

